module.exports = __webpack_public_path__ + "img/logo1.a89a89f5.png";